import { Routes, Route } from 'react-router-dom';
import { LanguageProvider } from '@/i18n';
import { ChatPage } from '@/pages/ChatPage';

function App() {
  return (
    <LanguageProvider>
      <Routes>
        <Route path="/" element={<ChatPage />} />
      </Routes>
    </LanguageProvider>
  );
}

export default App;
